module.exports = __webpack_public_path__ + "img/operationCapacity1.d56774e9.png";